<template>
    <div class="outer d-flex align-center">
        <div class="spin">
            <div :key="i" v-for="i in 8" class="segmento-spin"></div>
        </div>
        <p>Carregando Informações...</p>
        <p v-if="showAdditionalLoadingText" class="additional-text">
            {{ additionalLoadingText }}
        </p>
        <div v-if="CarregarLoading" class="loading-bar-wrapper mt-2">
            <div class="loading-bar-container">
                <div class="loading-bar" :style="{ width: loadingBarWidth + '%' }"></div>
            </div>
            <div class="loading-percentage ml-4 text--info" style="font-size:1.2rem">{{ percentage | percentage }}</div>
        </div>
    </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'Spin',
    data () {
      return {
        percentage: 0,
        intervalId: null
      }
    },
    computed: {
      ...mapState([
        'showAdditionalLoadingText',
        'additionalLoadingText',
        'CarregarLoading',
        'loading'
      ]),
      loadingBarWidth () {
        return this.percentage
      }
    },
    watch: {
      CarregarLoading: {
        handler (newVal) {
          if (newVal) {
            if (newVal === true) {
              this.percentage = 100
            } else {
              this.resetLoading()
              this.startLoading(newVal)
            }
          } else {
            this.resetLoading()
          }
        },
        immediate: true
      }
    },
    methods: {
      startLoading (loadingConfig) {
        const { totalTime, totalRequests } = loadingConfig
        const intervalDuration = totalTime / totalRequests
        let completedRequests = 0

        this.intervalId = setInterval(() => {
          if (completedRequests < totalRequests) {
            completedRequests += 1
            if (completedRequests === totalRequests) {
              const minPercentage = Math.max(this.percentage, 94) // Garante que a porcentagem não seja menor do que a atual
              const maxPercentage = 99
              this.percentage = Math.random() * (maxPercentage - minPercentage) + minPercentage // Gera um número entre 94 e 99
            } else {
              this.percentage = (completedRequests / totalRequests) * 100
            }
          } else {
            clearInterval(this.intervalId)
          }
        }, intervalDuration)
      },
      resetLoading () {
        clearInterval(this.intervalId)
        this.percentage = 0
      }
    }
  }
</script>

<style lang="scss" scoped>
$size: 100;
$length: 24;
$radius: ($size - $length) / 2;
$thickness: 8;
$segments: 8;
$angle: 360 / $segments;
$delay: 2 / $segments;

.outer {
  flex: none !important;
  flex-direction: column;
}

.spin {
  width: #{$size}px;
  height: #{$size}px;
  position: relative;
}

.segmento-spin {
  height: #{$thickness}px;
  width: #{$length}px;
  left: 50%;
  top: 50%;
  margin-left: #{- $length / 2}px;
  position: absolute;
  filter: brightness(50%);
  background: var(--info) !important;
  border-radius: 5px;
  animation: loading linear 2s infinite;
}

@for $i from 1 through $segments {
  .segmento-spin:nth-child(#{$i}) {
    transform: rotate(#{$i * $angle}deg) translate(#{$radius}px);
    animation-delay: #{$delay * $i}s;
  }
}

@keyframes loading {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

.loading-bar-wrapper {
  display: flex;
  align-items: center;
}

.loading-bar-container {
  width: 600px;
  max-width: 90vw;
  height: 10px;
  background-color: #f3f3f3;
  border-radius: 5px;
  overflow: hidden;
}

.loading-bar {
  height: 100%;
  background-color: var(--info);
  filter: brightness(105%);
  transition: width 0.5s;
}

p, .additional-text {
  font-size: 2rem;
  color: var(--info);
}

p {
  margin-top: 10px;
}

.additional-text {
  font-size: 1.4rem;
}
</style>
